import React from "react";

export default function SQLServer_ASCII() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_ASCII</h1>
      <p>This is the SQLServer_ASCII component generated from the SQL JSON.</p>
    </div>
  );
}
